/**
 * Some events are only dispatched very early, once, and with no payload.
 * Lets treat theme separately for the sake of minimizing bundle size.
 */

export enum EventTypeReady {
  FW_READY = 'fw:ready',
  FW_SHOPPING_READY = 'fw:shopping:ready',
  FW_PLAYER_READY = 'fw:player:ready',
  FW_PIP_READY = 'fw:pip:ready',
  FW_WIDGET_READY = 'fw:widget:ready',
}
